<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>Редактирование направлений</h6>
      </div>
      <div class="card-body">
        <div v-if="cities">
          <table class="table table-hover table-sm">
            <thead>
            <tr>
              <th>ID</th>
              <th>Склад</th>
              <th>Стикер</th>
              <th>Город</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(store, index) in sortArray(stores, 'title')">
              <tr>
                <td>{{ store.id }}</td>
                <td>{{ store.title }}</td>
                <td>
                  <input type="checkbox" v-model="settings[store.id].transit.stickers.int_value"/>
                </td>
                <td>
                  <select @change="store.is_changed = true" class="form-control" v-model="store.city_id">
                    <option value="0">Все другие города</option>
                    <option v-for="(city, id) in cities" :value="id">{{ city }}</option>
                  </select>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="text-right">
      <vue-ladda button-class="btn btn-success btn-sm" data-style="zoom-in"
                 @click="saveStoreData()"
                 :loading="btnLoading">Сохранить
      </vue-ladda>
    </div>

  </div>
</template>

<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  components: {
    VueLadda,
  },
  data() {
    return {
      btnLoading: false,
      cities: null,
      stores: [],
      settings: {},
    }
  },
  mounted() {
    this.getStores();
  },
  methods: {
    async saveStoreData() {
      this.btnLoading = true;
      const {data} = await api.post('/settings/updateStores', {
        stores: this.stores,
        settings: this.settings
      });
      if (data.success) {
        await this.getStores();
        toastr['success'](data.message || 'Обновлено');
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }
      this.btnLoading = false;
    },
    async getStores() {
      const {data} = await api.index('/settings/getStores');
      this.settings = data.stores.reduce((acc, s) => {
        if (!acc[s.id]) acc[s.id] = {
          transit: {
            stickers: {int_value: 0, sub_value: null}
          }
        };
        s.settings.forEach((ss) => {
          if (!['transit'].includes(ss.option_type)) return;
          if (!['stickers'].includes(ss.option)) return;
          if (!acc[s.id][ss.option_type]) acc[s.id][ss.option_type] = {};
          acc[s.id][ss.option_type][ss.option] = ss;
        })
        return acc;
      }, {})
      this.stores = [];
      data.stores.forEach((s) => {
        s.is_changed = false;
        this.stores.push({...s, settings: []});
      });
      this.cities = data.cities;
    }
  }
}

</script>
